export default {
  productionUpdate(state, data) {
    state.production = data;
  },

  warehouseUpdate(state, data) {
    state.warehouse = data;
  },

  productionDayUpdate(state, val) {
    const system = val.system;
    const model = val.model;
    const sub = val.sub;
    const day = val.day;

    if (sub !== null) {
      state.production[system].models[model].sub_models[sub].production.dealer = day;
      state.production[system].models[model].sub_models[sub].is_active = day === 0 ? false : true;
    } else {
      state.production[system].models[model].production.dealer = day;
      state.production[system].models[model].is_active = day === 0 ? false : true;
    }
  },

  updateProductionSelectDays(state, val) {
    const data = val.data;
    const day = val.day;
    const systemIndex = val.systemIndex;
    const modelIndex = val.modelIndex;

    if (modelIndex !== null) {
      const sub = state.production[systemIndex].models[modelIndex].sub_models;
      sub.forEach(item => {
        const index = data.findIndex(el => el.model_id === item.id);
        if (index !== -1) {
          item.production.dealer = day;
          item.is_active = day === 0 ? false : true;
        }
      })
    } else {
      const model = state.production[systemIndex];
      model.models.forEach(item => {
        if (!item.sub_models.length) {
          const index = data.findIndex(el => el.model_id === item.id);
          if (index !== -1) {
            item.production.dealer = day;
            item.is_active = day === 0 ? false : true;
          }
        } else if (item.sub_models.length) {
          item.sub_models.forEach(i => {
            const subIndex = data.findIndex(el => el.model_id === i.id);
            if (subIndex !== -1) {
              i.production.dealer = day;
              i.is_active = day === 0 ? false : true;
            }
          })
        }
      })
    }
  },

  productionDayMaterialUpdate(state, val) {
    state.production[val.index].models[val.itemIndex].production.dealer = val.day;
    state.production[val.index].models[val.itemIndex].is_active = val.day === 0 ? false : true;
  },

  warehouseDateUpdate(state, val) {
    for (let i = 0; i < val.selected.length; i++) {
      if (val.opt) {
        const selected = val.selected;
        const setData = (selected, list) => {
          selected.forEach((item, index) => {
            if (item.items.length) {
              item.items.forEach((el) => {
                const elIndex = list[index].items.findIndex(elem => elem.id === el);
                if (elIndex !== -1) {
                  if (list[index].items[elIndex].availability?.dealer && val.date) {
                    list[index].items[elIndex].availability.dealer.arrival_date = val.date;
                  }

                  if (val.availability) {
                    list[index].items[elIndex].availability.dealer.count = val.availability;
                  }
                }
              });
            }

            if (item.sub_categories.length) {
              setData(item.sub_categories, list[index].sub_categories);
            }
          })
        };
        setData(selected, state.warehouse.opt)
      } else {
        const list = val.selected[i].items;
        const change = (parent, type, index) => {
          if (state.warehouse[parent][i].items[index].availability?.dealer && val.date) {
            state.warehouse[parent][i].items[index].availability.dealer.arrival_date = val.date;
          }

          if (val.availability) {
            state.warehouse[parent][i].items[index].availability.dealer[type] = val.availability;
          }
        }

        if (list.length) {
          for (let e = 0; e < list.length; e++) {
            const sub = val.selected[i].items[e];
            if (val.opt) {
              const index = state.warehouse.opt[i].items.findIndex(item => item.id === sub);
              change('opt', 'count', index);
            } else {
              const index = state.warehouse.materials[i].items.findIndex(item => item.id === sub);
              if (val.type === 'all') {
                change('materials', 'zgi', index);
                change('materials', 'opt', index);
              } else {
                change('materials', val.type, index);
              }
            }
          }
        }

        for (let e = 0; e < val.selected[i].sub_categories.length; e++) {
          const categories = val.selected[i].sub_categories[e];
          const changeCategories = (parent, type, index) => {
            if (state.warehouse[parent][i].sub_categories[e].items[index].availability?.dealer && val.date) {
              state.warehouse[parent][i].sub_categories[e].items[index].availability.dealer.arrival_date = val.date;
            }

            if (val.availability && state.warehouse?.[parent]?.[i].sub_categories?.[e].items?.[index]?.availability?.dealer?.[type]) {
              state.warehouse[parent][i].sub_categories[e].items[index].availability.dealer[type] = val.availability;
            }
          }
          if (categories.length) {
            for (let k = 0; k < categories.length; k++) {
              const categoriesSub = val.selected[i].sub_categories[e][k];
              if (val.opt) {
                const index = state.warehouse.opt[i].sub_categories[e].items.findIndex(item => item.id === categoriesSub);
                changeCategories('opt', 'count', index);
              } else {
                const index = state.warehouse.materials[i].sub_categories[e].items.findIndex(item => item.id === categoriesSub); 
                if (val.type === 'all') {
                  changeCategories('materials', 'zgi', index);
                  changeCategories('materials', 'opt', index); 
                } else {
                  changeCategories('materials', val.type, index);
                }
              }
            }
          }
        }
      }
    }
  },

  updatePrices(state, payload) {
    state.prices.dealer = payload.dealer;
    state.prices.supplier = payload.supplier;
  },

  updatePricesPopup(state, {
    system = null,
    model = null,
    id = null,
   }) {
    state.pricesPopup.system = system;
    state.pricesPopup.model = model;
    state.pricesPopup.id = id;
  },

  updatePricesDealerType(state, payload) {
    state.prices.dealer.prices.price_type = payload;
  },

  updateCharge(state, {
    systemIndex,
    modelIndex,
    subIndex,
    id,
  }) {
    state.charge.systemIndex = systemIndex;
    state.charge.modelIndex = modelIndex;
    state.charge.subIndex = subIndex;
    state.charge.id = id;
  },

  updateProductionChargeDelete(state, charge) {
    const { systemIndex, modelIndex, subIndex } = state.charge;
    if (subIndex !== null) {
      state.production[systemIndex].models[modelIndex].sub_models[subIndex].charge = charge;
      state.production[systemIndex].models[modelIndex].sub_models[subIndex].is_default_charge = true;
    } else {
      state.production[systemIndex].models[modelIndex].charge = charge;
      state.production[systemIndex].models[modelIndex].is_default_charge = true;
    }
  },

  updateProductionCharge(state, {
    systemIndex,
    modelIndex,
    subIndex,
    charge,
    is_default_charge,
    charge_type,
    currency = null
  }) {
    if (subIndex !== null) {
      state.production[systemIndex].models[modelIndex].sub_models[subIndex].charge = charge;
      state.production[systemIndex].models[modelIndex].sub_models[subIndex].charge_type = charge_type;
      state.production[systemIndex].models[modelIndex].sub_models[subIndex].is_default_charge = is_default_charge;
      if (currency) {
        state.production[systemIndex].models[modelIndex].sub_models[subIndex].currency = currency;
      }
    } else {
      state.production[systemIndex].models[modelIndex].charge = charge;
      state.production[systemIndex].models[modelIndex].charge_type = charge_type;
      state.production[systemIndex].models[modelIndex].is_default_charge = is_default_charge;
      if (currency) {
        state.production[systemIndex].models[modelIndex].currency = currency;
      }
    }
  },
}
